"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var background = function (color) { return "background: " + color + ";"; };
exports.default = (function (_a) {
    var warning = _a.warning, success = _a.success, error = _a.error;
    return function (_a) {
        var theme = _a.theme;
        if (warning) {
            return background(theme.palette.bannerBackground[1]);
        }
        if (success) {
            return background(theme.palette.bannerBackground[2]);
        }
        if (error) {
            return background(theme.palette.bannerBackground[3]);
        }
        return background(theme.palette.bannerBackground[0]);
    };
});
